import { Component, OnInit } from "@angular/core";
import { environment } from "@environments/environment";
import { Router } from "@angular/router";
import { CommonService } from "@services/common.service";
import { IconDefinition } from "@fortawesome/pro-light-svg-icons";
import {
  faHome,
  faQuestionCircle,
  faCircleQuestion,
  faUser,
  faSignOut,
  faChartLine,
  faGaugeMax,
  faBell,
  faSearch,
  faTrashCan,
  faDatabase,
  faMessageMedical,
  faRoute,
  faUserGear,
  faArrowRightFromBracket,
  faStars,
} from "@fortawesome/pro-light-svg-icons";

const NavigationIcons: {
  [key: string]: IconDefinition;
} = {
  faHome: faHome,
  faQuestionCircle: faQuestionCircle,
  faCircleQuestion: faCircleQuestion,
  faUser: faUser,
  faSignOut: faSignOut,
  faChartLine: faChartLine,
  faGaugeMax: faGaugeMax,
  faBell: faBell,
  faSearch: faSearch,
  faTrashCan: faTrashCan,
  faDatabase: faDatabase,
  faMessageMedical: faMessageMedical,
  faRoute: faRoute,
  faUserGear: faUserGear,
  faArrowRightFromBracket: faArrowRightFromBracket,
};
@Component({
    selector: "app-navigation",
    templateUrl: "./navigation.component.html",
    styleUrls: ["./navigation.component.scss"],
    standalone: false
})
export class NavigationComponent implements OnInit {
  constructor(private router: Router, public commonService: CommonService) {}

  public collapsedMenuState = false;
  public navigation: any;

  faStars = faStars;
  getNavigationIcon(type: string): IconDefinition {
    return NavigationIcons[type];
  }

  goToHomeLink(link: string) {
    let userObject = JSON.parse(sessionStorage.getItem("userObject"));
    let enterpriseDashboardId = userObject.enterpriseDashboardId;

    if (!enterpriseDashboardId || enterpriseDashboardId == 0) {
      window.location.href = link;
    } else {
      let url = "/dashboards/view/" + enterpriseDashboardId;
      this.router.navigate([url]);
    }
  }
  generateLink(link: string, target: string) {
    const origin: string = window.location.origin;
    let returnLink = "";
    if (link && link.includes(origin)) {
      const url = link.split(origin);
      returnLink = url[1];
    } else {
      returnLink = link;
    }
    return returnLink;
  }

  localLink(link: string) {
    const origin: string = window.location.origin || "";
    let local = false;
    if (link && link.includes(origin)) {
      local = true;
    }
    return local;
  }

  getNavigation() {
    setTimeout(() => {
      let userObject = JSON.parse(sessionStorage.getItem("userObject"));
      if (userObject) {
        let mainMenu = userObject.mainMenus.data;
        if (mainMenu) {
          this.navigation = mainMenu.filter((item: any) => {
            return (
              item.title != "Alerts" &&
              item.title != "Search" &&
              item.title != "Help"
            );
          });
        }
      } else {
        this.getNavigation();
      }
    }, 100);
  }

  ngOnInit(): void {
    this.getNavigation();
  }
}
